import { Button, Card } from "@chef/components";
import { useBillingQuery } from "@chef/state-management";
import {
  isConceptPreference,
  isMealboxBasket,
  isMealboxBasketType,
  isTastePreference,
} from "@chef/helpers";
import { getAttribute } from "@chef/state-management/helpers";
import { isNotEmptyArray } from "@chef/utils/array";
import { BRAND_PATHS } from "@chef/constants";
import { Cooking } from "@chef/icons/symbol";
import { PreferencesDetails } from "@chef/smart-components";
import { STAGE, usePreselector } from "@chef/state-management/hooks";

import { intl } from "./PreferenceOverview.Intl";

export const PreferenceOverview = () => {
  const { data: billingQuery } = useBillingQuery();

  const { stage } = usePreselector();

  const isPreselectorRunning = stage > STAGE.IDLE && stage < STAGE.COMPLETED;

  if (!billingQuery) {
    return null;
  }

  const conceptPreferences =
    billingQuery.billing.preferences.filter(isConceptPreference);

  const tastePreferences =
    billingQuery.billing.preferences.filter(isTastePreference);

  const mealboxVariation = billingQuery.billing.baskets
    .find(isMealboxBasketType)
    ?.basketProducts.find(isMealboxBasket)?.variation;

  if (!mealboxVariation) {
    return null;
  }

  const portions = getAttribute("Portions", mealboxVariation);
  const meals = getAttribute("Meals", mealboxVariation);
  const hasConceptPreferences = isNotEmptyArray(conceptPreferences);
  const hasTastePreferences = isNotEmptyArray(tastePreferences);
  const hasNoPreferences = !hasConceptPreferences && !hasTastePreferences;

  return (
    <div className="mx-0 bg-grey-2 page-padding grow">
      <div className="page-max-width page-grid">
        <Card className="p-4 mb-20 mt-28 col-span-full md:col-span-6 xl:col-span-4 xl:col-start-5 md:col-start-2">
          <div className="relative flex flex-col items-center gap-6 pb-6 bg-white pt-14">
            <div className="absolute border-4 border-white rounded-full -top-16 bg-grey-3">
              <Cooking width={96} height={96} className="p-4" />
            </div>
            <div className="flex flex-col items-center gap-1">
              <h1 className="text-xl">
                <strong>{intl.YOUR_MEALBOX}</strong>
              </h1>
              <p className="text-sm">{intl.DESIGNED_BY_YOU}</p>
            </div>
            <div className="flex flex-col items-center w-full gap-2">
              <p className="text-sm">
                {portions && meals && (
                  <strong>
                    {intl.FOOD_FOR_N_PEOPLE_N_MEALS(portions, meals)}
                  </strong>
                )}
              </p>
              <PreferencesDetails
                conceptPreferences={conceptPreferences}
                tastePreferences={tastePreferences}
                className="w-full"
              />
            </div>
            <Button
              small
              outlined
              href={BRAND_PATHS.MEALBOX_PREFERENCE}
              disabled={isPreselectorRunning}
            >
              {hasNoPreferences
                ? intl.SELECT_YOUR_PREFERENCES
                : intl.CHANGE_YOUR_PREFERENCES}
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};
